import React, { ReactNode } from 'react';
import './contact-center.scss';

type Props = {
    config: {
        phone?: string;
        mail?: string;
        url?: string;
        qrSrc?: string;
    };
    src?: string;
    icon?: ReactNode;
    style?: {
        fontSize?: number;
    };
};

const ContactCenter = ({ config, src, icon, style }: Props) => {
    const content = config.phone ?? config.mail ?? '';
    const textNode = config.url ? (
        <a
            className="contact-text contact-link"
            href={config.url}
            target="_blank"
            rel="noopener noreferrer"
        >
            {content}
        </a>
    ) : (
        <span className="contact-text">{content}</span>
    );

    return (
        <div
            className={`contact-center${config.qrSrc ? ' contact-center--with-qr' : ''}`}
            style={style}
        >
            {src && (
                <img
                    src={src}
                    alt=""
                />
            )}
            {icon}
            {textNode}
            {config.qrSrc && (
                <div className="contact-center__qr">
                    <img
                        src={config.qrSrc}
                        alt={content || 'QR'}
                    />
                </div>
            )}
        </div>
    );
};

export default ContactCenter;
